import { render, staticRenderFns } from "./BirdDogDecoderDocument.vue?vue&type=template&id=38759000"
import script from "./BirdDogDecoderDocument.vue?vue&type=script&lang=js"
export * from "./BirdDogDecoderDocument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports